import type { ReactNode } from 'react'

import { t } from '../../i18n'

/**
 * A short "why?" that stays folded until somebody wants it.
 *
 * The inventory screen has three or four rules that are not guessable from
 * looking at it -- letting a room stops the flat being offered, an empty price
 * field is not a zero, "we are offering it" is what the assistant may put in
 * front of a client. A person who does not know them will do the wrong thing
 * once and then distrust the screen.
 *
 * Folded rather than printed, because a rule explained in a paragraph above
 * every control is a paragraph nobody reads twice and clutter for the person who
 * already knows. It sits next to the thing it is about, so the question and the
 * answer are in the same place.
 */
export function Explain({ children }: { readonly children: ReactNode }) {
  return (
    <details className="explain">
      <summary className="explain__ask">{t('explain.why')}</summary>
      <div className="explain__body">{children}</div>
    </details>
  )
}
